import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function leadBreakupCountDataReducer(state = initialState.leadBreakupCountData, action) {
  switch (action.type) {
    case types.LOAD_LEADBREAKUP_DATA_SUCCESS:
      return action.leadBreakupCountData;
    default:
      return state;
  }
}
